@use "ui/styles/fonts";
@use "ui/styles/sizes";

.compactTable {
  td,
  th {
    min-height: 32px !important;
    padding: 4px 10px !important;
  }

  font-size: fonts.$small;
}

.filterRow {
  display: flex;
  gap: sizes.$s4;
  padding-left: sizes.$s6;
}

.filterToolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: sizes.$s3 sizes.$s4;
  padding: sizes.$s4 sizes.$s3 sizes.$s5;
}

.filterSelect {
  width: 180px;
}


.changeCell {
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow: hidden;
  line-height: 1.3;
}

.oldValue {
  text-decoration: line-through;
  opacity: 0.45;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.newValue {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dateCell {
  display: flex;
  align-items: center;
  gap: sizes.$s1;
  white-space: nowrap;
}

.optionName {
  display: block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.truncatedCell {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.archiveSummary {
  font-style: italic;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
}

.fieldLabel {
  font-family: monospace;
  font-size: fonts.$smallX2;
  letter-spacing: -0.02em;
  line-height: 1.25;
  // Override Capsule's nowrap behavior so long labels can wrap.
  white-space: normal;
  overflow-wrap: break-word;
}

.mutedLabel {
  opacity: 0.5;
}

.mutedItalic {
  opacity: 0.5;
  font-style: italic;
}
